/**
 * Analytics provider configuration (Milestone 15).
 * TODO: Wire cookie/consent banner when privacy policy requires opt-in.
 */

const GA_ENV_KEYS = [
  "REACT_APP_GA_MEASUREMENT_ID",
  "VITE_GA_MEASUREMENT_ID",
  "NEXT_PUBLIC_GA_MEASUREMENT_ID",
];

const GTM_ENV_KEYS = ["REACT_APP_GTM_ID", "VITE_GTM_ID", "NEXT_PUBLIC_GTM_ID"];

const ENABLED_ENV_KEYS = ["PUBLIC_ANALYTICS_ENABLED", "REACT_APP_ANALYTICS_ENABLED", "VITE_ANALYTICS_ENABLED"];

function readEnv(keys) {
  if (typeof process === "undefined" || !process.env) return null;
  for (const key of keys) {
    const value = process.env[key];
    if (value?.trim()) return value.trim();
  }
  return null;
}

export function getGaMeasurementId() {
  return readEnv(GA_ENV_KEYS);
}

export function getGtmContainerId() {
  return readEnv(GTM_ENV_KEYS);
}

export function isPublicAnalyticsEnabled() {
  const flag = readEnv(ENABLED_ENV_KEYS);
  if (flag === "false" || flag === "0") return false;
  return true;
}

export function isAnalyticsDebugMode() {
  return process.env.NODE_ENV !== "production";
}
